import {
  STRING_getInstance2ou4lro9xn2qn as STRING_getInstance,
  LONG_getInstance3408a5feo2kfb as LONG_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import {
  PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor,
  buildClassSerialDescriptors2a6xdp6mrtw as buildClassSerialDescriptor,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance,
  UUID21wrnrlmk5y1y as UUID,
} from '../UUID.js.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance3vjikuur3h0k4 as Companion_getInstance_0,
  Instant3cn81rq2kpflk as Instant,
} from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import {
  Companion_getInstancefc1kb6w5z78x as Companion_getInstance_1,
  LocalDate31mqn6zavbpi8 as LocalDate,
} from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDate.mjs';
import {
  Companion_getInstance3vhybkmm49bju as Companion_getInstance_2,
  LocalTime22kisvxz6f9p4 as LocalTime,
} from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalTime.mjs';
import {
  Companion_getInstance2vzevs5m6d283 as Companion_getInstance_3,
  LocalDateTime3vqv9moe7clf4 as LocalDateTime,
} from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_4,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b11f1kpclwmkpg as Duration__toString_impl_8d916b,
  toDurationba1nlt78o6vu as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { rangeTo3js8ciqegc9cl as rangeTo } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/Ranges.mjs';
import { ClosedRangehokgr73im9z3 as ClosedRange } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/Range.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UUIDSerializerClass;
function UUIDSerializer() {
  if (UUIDSerializerClass === VOID) {
    class $ {
      constructor() {
        UUIDSerializer_instance = this;
        this.b4r_1 = PrimitiveSerialDescriptor('com.lightningkite.UUID', STRING_getInstance());
      }
      pz(decoder) {
        var tmp;
        try {
          tmp = Companion_getInstance().xw(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      az() {
        return this.b4r_1;
      }
      q3n(encoder, value) {
        return encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.q3n(encoder, value instanceof UUID() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'UUIDSerializer', VOID, VOID, [KSerializer()]);
    UUIDSerializerClass = $;
  }
  return UUIDSerializerClass;
}
var UUIDSerializer_instance;
function UUIDSerializer_getInstance() {
  if (UUIDSerializer_instance === VOID)
    new (UUIDSerializer())();
  return UUIDSerializer_instance;
}
var InstantIso8601SerializerClass;
function InstantIso8601Serializer() {
  if (InstantIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        InstantIso8601Serializer_instance = this;
        this.c4r_1 = PrimitiveSerialDescriptor('kotlinx.datetime.Instant/loose', STRING_getInstance());
      }
      az() {
        return this.c4r_1;
      }
      pz(decoder) {
        var tmp;
        try {
          tmp = Companion_getInstance_0().g25(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      h25(encoder, value) {
        return encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.h25(encoder, value instanceof Instant() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'InstantIso8601Serializer', VOID, VOID, [KSerializer()]);
    InstantIso8601SerializerClass = $;
  }
  return InstantIso8601SerializerClass;
}
var InstantIso8601Serializer_instance;
function InstantIso8601Serializer_getInstance() {
  if (InstantIso8601Serializer_instance === VOID)
    new (InstantIso8601Serializer())();
  return InstantIso8601Serializer_instance;
}
var LocalDateIso8601SerializerClass;
function LocalDateIso8601Serializer() {
  if (LocalDateIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        LocalDateIso8601Serializer_instance = this;
        this.e4r_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDate/loose', STRING_getInstance());
      }
      az() {
        return this.e4r_1;
      }
      pz(decoder) {
        var tmp;
        try {
          tmp = Companion_getInstance_1().l25(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      m25(encoder, value) {
        return encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.m25(encoder, value instanceof LocalDate() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalDateIso8601Serializer', VOID, VOID, [KSerializer()]);
    LocalDateIso8601SerializerClass = $;
  }
  return LocalDateIso8601SerializerClass;
}
var LocalDateIso8601Serializer_instance;
function LocalDateIso8601Serializer_getInstance() {
  if (LocalDateIso8601Serializer_instance === VOID)
    new (LocalDateIso8601Serializer())();
  return LocalDateIso8601Serializer_instance;
}
var LocalTimeIso8601SerializerClass;
function LocalTimeIso8601Serializer() {
  if (LocalTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        LocalTimeIso8601Serializer_instance = this;
        this.d4r_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalTime/loose', STRING_getInstance());
      }
      az() {
        return this.d4r_1;
      }
      pz(decoder) {
        var tmp;
        try {
          tmp = Companion_getInstance_2().v25(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      w25(encoder, value) {
        return encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.w25(encoder, value instanceof LocalTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    LocalTimeIso8601SerializerClass = $;
  }
  return LocalTimeIso8601SerializerClass;
}
var LocalTimeIso8601Serializer_instance;
function LocalTimeIso8601Serializer_getInstance() {
  if (LocalTimeIso8601Serializer_instance === VOID)
    new (LocalTimeIso8601Serializer())();
  return LocalTimeIso8601Serializer_instance;
}
var LocalDateTimeIso8601SerializerClass;
function LocalDateTimeIso8601Serializer() {
  if (LocalDateTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        LocalDateTimeIso8601Serializer_instance = this;
        this.f4r_1 = PrimitiveSerialDescriptor('kotlinx.datetime.LocalDateTime/loose', STRING_getInstance());
      }
      az() {
        return this.f4r_1;
      }
      pz(decoder) {
        var tmp;
        try {
          tmp = Companion_getInstance_3().q25(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      r25(encoder, value) {
        return encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.r25(encoder, value instanceof LocalDateTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'LocalDateTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    LocalDateTimeIso8601SerializerClass = $;
  }
  return LocalDateTimeIso8601SerializerClass;
}
var LocalDateTimeIso8601Serializer_instance;
function LocalDateTimeIso8601Serializer_getInstance() {
  if (LocalDateTimeIso8601Serializer_instance === VOID)
    new (LocalDateTimeIso8601Serializer())();
  return LocalDateTimeIso8601Serializer_instance;
}
var DurationSerializerClass;
function DurationSerializer() {
  if (DurationSerializerClass === VOID) {
    class $ {
      constructor() {
        DurationSerializer_instance = this;
        this.g4r_1 = PrimitiveSerialDescriptor('kotlin.time.Duration/loose', STRING_getInstance());
      }
      m15(decoder) {
        var tmp;
        try {
          tmp = Companion_getInstance_4().wu(decoder.h13());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof IllegalArgumentException()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      pz(decoder) {
        return new (Duration())(this.m15(decoder));
      }
      az() {
        return this.g4r_1;
      }
      l15(encoder, value) {
        return encoder.p14(Duration__toString_impl_8d916b(value));
      }
      oz(encoder, value) {
        return this.l15(encoder, value instanceof Duration() ? value.nj_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DurationSerializer', VOID, VOID, [KSerializer()]);
    DurationSerializerClass = $;
  }
  return DurationSerializerClass;
}
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance === VOID)
    new (DurationSerializer())();
  return DurationSerializer_instance;
}
var ClosedRangeSerializerClass;
function ClosedRangeSerializer() {
  if (ClosedRangeSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        this.e4s_1 = inner;
        var tmp = this;
        tmp.f4s_1 = buildClassSerialDescriptor('kotlin.ranges.ClosedRange', [], ($this$buildClassSerialDescriptor) => {
          $this$buildClassSerialDescriptor.zz('start', this.e4s_1.az());
          $this$buildClassSerialDescriptor.zz('endInclusive', this.e4s_1.az());
          return Unit_instance;
        });
      }
      az() {
        return this.f4s_1;
      }
      pz(decoder) {
        var start = {_v: null};
        var endInclusive = {_v: null};
        // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
        var descriptor = this.f4s_1;
        var composite = decoder.l13(descriptor);
        $l$loop: while (true) {
          var index = composite.b14(this.f4s_1);
          switch (index) {
            case -1:
              break $l$loop;
            case -3:
              break;
            case 0:
              start._v = composite.y13(this.f4s_1, index, this.e4s_1);
              break;
            case 1:
              endInclusive._v = composite.y13(this.f4s_1, index, this.e4s_1);
              break;
          }
        }
        var result = Unit_instance;
        composite.m13(descriptor);
        var tmp;
        if (start._v == null) {
          throwUninitializedPropertyAccessException('start');
        } else {
          tmp = start._v;
        }
        var tmp_0 = tmp;
        var tmp_1;
        if (endInclusive._v == null) {
          throwUninitializedPropertyAccessException('endInclusive');
        } else {
          tmp_1 = endInclusive._v;
        }
        return rangeTo(tmp_0, tmp_1);
      }
      g4s(encoder, value) {
        // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
        var descriptor = this.f4s_1;
        var composite = encoder.l13(descriptor);
        composite.c15(this.f4s_1, 0, this.e4s_1, value.j1());
        composite.c15(this.f4s_1, 1, this.e4s_1, value.k1());
        composite.m13(descriptor);
      }
      oz(encoder, value) {
        return this.g4s(encoder, (!(value == null) ? isInterface(value, ClosedRange()) : false) ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'ClosedRangeSerializer', VOID, VOID, [KSerializer()]);
    ClosedRangeSerializerClass = $;
  }
  return ClosedRangeSerializerClass;
}
var DurationMsSerializerClass;
function DurationMsSerializer() {
  if (DurationMsSerializerClass === VOID) {
    class $ {
      constructor() {
        DurationMsSerializer_instance = this;
        this.h4r_1 = PrimitiveSerialDescriptor('kotlin.time.Duration/milliseconds', LONG_getInstance());
      }
      m15(decoder) {
        var tmp;
        try {
          Companion_getInstance_4();
          // Inline function 'kotlin.time.Companion.milliseconds' call
          var this_0 = decoder.d13();
          tmp = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Exception()) {
            var e = $p;
            throw SerializationException().p10(e.message);
          } else {
            throw $p;
          }
        }
        return tmp;
      }
      pz(decoder) {
        return new (Duration())(this.m15(decoder));
      }
      az() {
        return this.h4r_1;
      }
      l15(encoder, value) {
        return encoder.l14(_Duration___get_inWholeMilliseconds__impl__msfiry(value));
      }
      oz(encoder, value) {
        return this.l15(encoder, value instanceof Duration() ? value.nj_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DurationMsSerializer', VOID, VOID, [KSerializer()]);
    DurationMsSerializerClass = $;
  }
  return DurationMsSerializerClass;
}
var DurationMsSerializer_instance;
function DurationMsSerializer_getInstance() {
  if (DurationMsSerializer_instance === VOID)
    new (DurationMsSerializer())();
  return DurationMsSerializer_instance;
}
//region block: exports
export {
  ClosedRangeSerializer as ClosedRangeSerializer28fgvycwrq3dm,
  DurationMsSerializer_getInstance as DurationMsSerializer_getInstance132uar9zvq19v,
  DurationSerializer_getInstance as DurationSerializer_getInstance3b3q4n80uazai,
  InstantIso8601Serializer_getInstance as InstantIso8601Serializer_getInstance2pw1uiz054ejd,
  LocalDateIso8601Serializer_getInstance as LocalDateIso8601Serializer_getInstance3gidjo5oele30,
  LocalDateTimeIso8601Serializer_getInstance as LocalDateTimeIso8601Serializer_getInstance302qwxjrznnmc,
  LocalTimeIso8601Serializer_getInstance as LocalTimeIso8601Serializer_getInstanceywsvdjhmwgt0,
  UUIDSerializer_getInstance as UUIDSerializer_getInstance2ms0oa88en0c,
};
//endregion

//# sourceMappingURL=Serializers.mjs.map
